"use client";

import Link from "next/link";
import { DesignFace } from "@/components/design-face";
import { LogoutButton } from "@/components/logout-button";
import { publicShell, serif } from "@/components/public-type";
import type { StudioLooks } from "@/lib/looks";

export function StudioIndex({
  studios,
  signedIn,
  showDashboard,
}: {
  studios: StudioLooks[];
  signedIn: boolean;
  showDashboard: boolean;
}) {
  return (
    <div className={publicShell}>
      <header className="mx-auto flex max-w-6xl items-center justify-between px-6 py-6">
        <p className={`${serif} text-3xl tracking-tight italic`}>Nails Studio</p>
        <div className="flex items-center gap-4">
          {showDashboard ? (
            <Link href="/dashboard" className="text-sm tracking-wide text-[#7d6874]">
              Dashboard
            </Link>
          ) : null}
          {signedIn ? (
            <LogoutButton redirectTo="/" className="text-sm tracking-wide text-[#7d6874]" />
          ) : (
            <Link href="/login" className="text-sm tracking-wide text-[#7d6874]">
              Sign in
            </Link>
          )}
        </div>
      </header>

      <section className="mx-auto max-w-6xl px-6 pt-2 pb-16">
        <h1 className={`${serif} text-6xl leading-[0.9] font-medium tracking-tight italic sm:text-8xl`}>Studios</h1>

        {studios.length === 0 ? (
          <p className={`${serif} mt-16 text-4xl text-[#7d6874] italic`}>No studios yet.</p>
        ) : (
          <ul className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3">
            {studios.map((studio) => {
              const cover = studio.designs[0];
              return (
                <li key={studio.id}>
                  <Link href={`/studios/${studio.id}`} className="group relative block overflow-hidden rounded-[32px] bg-[#f6d7dd]">
                    <div className="aspect-[3/4] transition duration-500 group-hover:scale-[1.03]">
                      {cover?.imageUrl ? (
                        <DesignFace name={studio.name} imageUrl={cover.imageUrl} swatch={null} />
                      ) : (
                        <div className="grid h-full place-items-center bg-[linear-gradient(145deg,#f6d7dd,#f3e6c4)]">
                          <span className={`${serif} px-4 text-center text-5xl text-[#d2a147] italic`}>{studio.title}</span>
                        </div>
                      )}
                    </div>
                    {cover?.imageUrl ? (
                      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#25122a]/80 to-transparent px-6 pt-16 pb-6">
                        <h2 className={`${serif} text-5xl text-[#f6d7dd] italic`}>{studio.title}</h2>
                      </div>
                    ) : null}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </section>
    </div>
  );
}
